import React from 'react'
import './index.css'


const Message = (props) => <h1 name={"msg"} className='message'>{props.value}</h1>	

export default Message